import { render, staticRenderFns } from "./MessageReceivers.vue?vue&type=template&id=5a3abbb6&scoped=true"
import script from "./MessageReceivers.vue?vue&type=script&lang=js"
export * from "./MessageReceivers.vue?vue&type=script&lang=js"
import style0 from "./MessageReceivers.vue?vue&type=style&index=0&id=5a3abbb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3abbb6",
  null
  
)

export default component.exports